export default __webpack_public_path__ + "static/media/amateurBg.b0f6a2ee.png";